import React, { useEffect, useState } from 'react';
import { TbCheck } from 'react-icons/tb';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { getStepperCheck } from '../../api/AccountSetup';
import { HOSPITALITY_LIST, NEW_LIST, OTHER_LIST, RETAILER_LIST } from './pages/DATA';
import getCustomMenuEffect from '../../hooks/Menu';
import { useMenuContext } from '../../Contexts/MenuContext';

const Stepper = () => {
  const location = useLocation();
  const { menuList } = useMenuContext();
  const uuid = sessionStorage.getItem('companyUuid');
  const businessType = sessionStorage.getItem('businessType');
  const { menu } = getCustomMenuEffect(uuid ? uuid : '');

  const [accountDetails, setAccountDetails] = useState<any>(null);
  const [currentStep, setCurrentStep] = useState(1);

  const fetchData = async () => {
    try {
      const company = await getStepperCheck(uuid ? uuid : '');
      setAccountDetails(company?.payload);
    } catch (error) {
      console.error('Error fetching account details:', error);
    }
  };

  const handleStepClick = (stepId: number) => {
    setCurrentStep(stepId);
  };

  const steps =
    businessType === 'Retail'
      ? RETAILER_LIST
      : businessType === "WordpressRetail" || businessType === 'OdooRetail' ? NEW_LIST
        : businessType === 'Hospitality' && menuList.includes('Services')
          ? HOSPITALITY_LIST
          : OTHER_LIST;

  const submittedStep = accountDetails ?? {
    companyDetail: '',
    faq: '',
    widget: '',
    integration: ''
  };

  useEffect(() => {
    fetchData();
  }, [location.pathname]);

  return (
    <>
      <div className="hidden 820:block">
        <div className="flex flex-col justify-center lg:ms-6 ms-6 mt-10 lg:mt-0">
          <div className="flex flex-col justify-center lg:ms-6 my-auto flex-1">
            {steps.map((step, index) => (
              <div key={index} className="flex">
                <div className="flex flex-col items-center">
                  <Link
                    to={
                      submittedStep[step.dbName] === 'completed'
                        ? step.stepUrl
                        : `${window.location.pathname}`
                    }
                  >
                    <div
                      className={`rounded-full lg:w-6 lg:h-6 md:w-5 md:h-5 w-4 h-4 border-2 cursor-pointer ${step.stepUrl === location.pathname ? 'p-[3px]' : 'p-0'
                        } mt-0`}
                      onClick={
                        submittedStep[step.dbName] === 'completed'
                          ? () => handleStepClick(step.id)
                          : undefined
                      }
                    >
                      <span
                        className={`flex items-center justify-center w-full h-full rounded-full ${step.stepUrl === location.pathname
                          ? 'bg-blue-500 text-white border-none'
                          : 'border-[#FFFFFF] text-white'
                          }`}
                      >
                        {submittedStep[step.dbName] === 'completed' &&
                          step.stepUrl !== location.pathname ? (
                          <TbCheck className="w-5 h-5" />
                        ) : (
                          <span className="block w-3 h-3 rounded-full bg-transparent border-none"></span>
                        )}
                      </span>
                    </div>
                  </Link>
                  {index !== steps.length - 1 && (
                    <div className="h-20 border-l-2 border-dashed border-[#ffffff]"></div>
                  )}
                </div>

                <div className="ml-2 mt-[-5px] lg:mt-0 pt-0">
                  <span className="lg:text-sm md:text-[14px] text-[12px] text-white font-normal">
                    <Link
                      to={
                        submittedStep[step.dbName] === 'completed'
                          ? step.stepUrl
                          : `${window.location.pathname}`
                      }
                    >
                      {step.step}
                    </Link>
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="block 820:hidden">
        <div className="flex flex-row flex-grow justify-between items-center mb-5 lg:mt-5 w-[100%]">
          {steps.map((step, index) => (
            <div key={index} className="flex flex-col items-center  w-full">
              <div className="mb-2 text-center">
                <span className="lg:text-[18px] md:text-[12px] text-[8px] text-white font-normal">
                  <Link
                    to={
                      submittedStep[step.dbName] === 'completed'
                        ? step.stepUrl
                        : `${window.location.pathname}`
                    }
                  >
                    {step.step}
                  </Link>
                </span>
              </div>

              <div
                className={`flex ${index === steps.length - 1
                  ? `justify-center items-center  w-full  `
                  : `${steps.length - 4 ? 'ml-[52px] 400-420:ml-[57px]  420-450:ml-[62px] 451-464:ml-[69px] 465-490:ml-[70px]  491-530:ml-[77px] 530-569:ml-[86px]  570-600:ml-[92px] 603-639:ml-[101px] sm:ml-[109px] 686-710:ml-[115px] 711-740:ml-[121px] 740-767:ml-[128px]  ' : 'ml-[70px] 390-425:ml-[78px] 420-450:ml-[81px] 450-500:ml-[93px] 501-550:ml-[106px] 551-570:ml-[116px] 570-600:ml-[120px] 603-639:ml-[128px] 670-699:ml-[148px] 700-720:ml-[155px] 721-748:ml-[158px]  749-767:ml-[168px] sm:ml-[138px] '} md:ml-[85%] w-full justify-center items-center`
                  }`}
              >
                <Link
                  to={
                    submittedStep[step.dbName] === 'completed'
                      ? step.stepUrl
                      : `${window.location.pathname}`
                  }
                >
                  <div
                    className={`rounded-full lg:w-6 lg:h-6 md:w-5 md:h-5 w-4 h-4 border-2 cursor-pointer flex items-center justify-center ${step.stepUrl === location.pathname ? 'p-[3px]' : 'p-0'
                      }`}
                    onClick={
                      submittedStep[step.dbName] === 'completed'
                        ? () => handleStepClick(step.id)
                        : undefined
                    }
                  >
                    <span
                      className={`w-full h-full rounded-full flex items-center justify-center ${step.stepUrl === location.pathname
                        ? 'bg-blue-500 text-white border-none'
                        : 'border-[#FFFFFF] text-white'
                        }`}
                    >
                      {submittedStep[step.dbName] === 'completed' &&
                        step.stepUrl !== location.pathname ? (
                        <TbCheck className="w-5 h-5" />
                      ) : (
                        <span className="block w-3 h-3 rounded-full bg-transparent border-none"></span>
                      )}
                    </span>
                  </div>
                </Link>

                {index !== steps.length - 1 && (
                  <div className="flex-grow h-[2px] border-dashed border-t-2 border-[#ffffff]"></div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Stepper;
